import { getNewConversionsFromSessionStorage } from 'modules/codeless-events/utils/codelessSessionStorageUtils';

export const codelessInitialValues = {
    conversions: getNewConversionsFromSessionStorage(),
    existingConversionIdsOnThisPage: [],
};
